import Swiper from "swiper/bundle";

import "swiper/css/bundle";

export default () => {
    const swiper01 = new Swiper(".swiper01", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        centeredSlides: false,
        mousewheel: true,
        breakpoints: {
            768: {
                slidesPerView: 1.7,
                spaceBetween: 40,
                centeredSlides: false,
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
};